<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-16 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-21 11:37:21
 * @FilePath: 
 * @Description: 会员卡片展示组件
-->
<template>
  <div>
    <van-cell
      v-for="(item, i) in cardList"
      :key="i"
      clickable
      @click="handleClickCard(item)"
    >
      <template #icon>
        <slot name="icon" :cardItem="item"></slot>
        <!-- <van-radio
                :name="item.CardTypeId"
                class="c-p-r-20"
                @click.native.stop="itemCheckHandler(item)"
              >
                <template #icon="props">
                  <img
                    style="width: 22px"
                    :src="props.checked ? activeIcon : inactiveIcon"
                  />
                </template>
              </van-radio> -->
      </template>
      <template #title>
        <div class="c-fl">
          <div class="">
            <g-img
              :src="item.PhotoUrl || $root.defaultImg"
              size="160"
              height="60px"
              :normal="true"
              class="l-img c-p-r-20"
            />
          </div>
          <div class="txt-box" v-if="item.isSecondary">
            <div class="main-title">{{ item.PlanName }}</div>
            <div class="sub-title">{{ item.TotalTimes }}</div>

            <div>
              <span>售价：</span>
              <span>{{ item.RealMoney }}元</span>
            </div>
          </div>
          <div class="txt-box" v-else>
            <div class="main-title">{{ item.CardTypeName }}</div>
            <template v-if="fromPage == 'recharge'">
              <div>
                <span>卡号：</span>
                <span>{{ item.CardCode }}</span>
              </div>
              <div>
                <span>余额：</span>
                <span>{{ item.allMoney }}元</span>
              </div>
              <div>
                <span>有效期至：</span>
                <span>{{ item.EndTime }}</span>
              </div>
            </template>
            <template v-else>
              <div class="sub-title" v-if="!fromPage || fromPage == 'pay'">
                {{ "默认次卡：" + item.DefaultTimesCardPlans.length + "项" }}
              </div>

              <div>
                <span>面值：</span>
                <span>{{ item.DefaultMoney }}元</span>
              </div>
            </template>
            <div v-if="fromPage == 'pay' || fromPage == 'recharge'">
              <span>充值金额：</span>
              <span>{{ rechargeMoney }}元</span>
            </div>
            <!-- <div>
                    <span>售价：</span>
                    <span class="c-tc">{{ item.ShiShou }}</span>
                    <span class="c-tc">元</span>
                  </div> -->
          </div>
        </div>
      </template>
      <template #right-icon>
        <div class="c-fl" v-if="fromPage !== 'recharge'">
          <g-arrow :width="16"></g-arrow>
        </div>
      </template>
    </van-cell>
    <g-model :show.sync="isCardShow" title="卡种说明">
      <template v-if="detailInfo.isSecondary">
        <div class="card_img_con">
          <img :src="detailInfo.PhotoUrl || $root.defaultImg" alt="" />
        </div>

        <van-cell title="项目名称" :value="detailInfo.PlanName" />
        <van-cell title="次数" :value="detailInfo.TotalTimes" />
        <van-cell title="售价" :value="detailInfo.RealMoney" />
      </template>
      <template v-else>
        <div class="card_img_con">
          <img :src="detailInfo.PhotoUrl || $root.defaultImg" alt="" />
        </div>

        <van-cell title="卡种名称" :value="detailInfo.CardTypeName" />
        <van-cell title="面值" :value="detailInfo.DefaultMoney" />
        <van-cell title="默认次卡" :value="detailInfo.cardNameStr" />
        <!-- <van-cell title="折扣方案" :value="detailInfo.DiscountName" /> -->
      </template>

      <!-- <van-collapse v-if="detailInfo.Discounts.length > 0" v-model="activeName">
        <van-collapse-item title="折扣方案" name="1">
          <van-cell
            :border="false"
            v-for="item in detailInfo.Discounts"
            :key="item.VpnId"
            :title="item.VpnName"
            :value="item.DiscountName"
            value-class="discount_value_con"
          />
        </van-collapse-item>
      </van-collapse> -->
    </g-model>
  </div>
</template>

<script>
export default {
  name: "GoodsListCard",
  props: {
    cardList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    fromPage: {
      type: String,
      default: "",
    },
    rechargeMoney: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isCardShow: false,
      detailInfo: {},
    };
  },
  created() {},
  methods: {
    // 点击查看卡详情
    handleClickCard(v) {
      if (this.fromPage == "recharge") return;
      this.isCardShow = true;
      const cardNameArr = !v.isSecondary
        ? v.DefaultTimesCardPlans.map((item) => item.PlanName)
        : [];
      console.log(cardNameArr);
      this.detailInfo = {
        ...v,
        cardNameStr: cardNameArr.join("、"),
      };
      // if(v.isSecondary){//点击次卡

      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.card_img_con {
  text-align: center;
  margin: 30px 0;
  img {
    width: 182px;
    height: 116px;
  }
}
</style>
